<template>
	<div class='dynamics-wrap'>

		<div class="flex border-5 tab-list">
			<div class="border-5" v-for="item in tabList" :key="item.id" :class="{active: item.id===tabId}" @click="tabHandle(item)">{{item.name}}</div>
		</div>
		<div class="list-wrap wrap-border">
			<ul class="" v-if="list.length>0">
				<li class="both-link" v-for="item in list" :key="item.id">
					<router-link class="flex flex-row-between" target="_blank"
						:to="`/company?number=${item.number}&tab=${tabId==1?'行政许可':'行政处罚'}${[2,4].includes(+item.type)?'&name='+item.name:''}`" tag="a">
						<p class="ellipsis-1">{{item.name}}</p>
						<p>{{item.decisionDate|timeFilter}}</p>
					</router-link>
				</li>
			</ul>
			<empty v-else />
		</div>
		<el-pagination v-if="list.length>0" background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />

	</div>
</template>

<script>
import { bothPublic } from '@/api'
import empty from '@/components/empty'
export default {
	components: {
		empty
	},
	data() {
		return {
			tabList: [
				{
					id: 1,
					name: '行政许可',
					code: '1,2'
				},
				{
					id: 2,
					name: '行政处罚',
					code: '3,4'
				},
			],
			tabId: 1,

			list: [],
			total: 0,
			pageSize: 10
		};
	},
	created() {
		const { query } = this.$route;
		const { tab } = query || {};
		if (tab) {
			this.$set(this, 'tabId', (tab.includes('行政处罚') || tab == 2) ? 2 : 1);
		}

	},
	mounted() {
		this.$emit('layoutInit', {
			menus: '行政许可'
		})
		this.getList()
	},
	methods: {
		tabHandle(row) {
			const { id, name } = row;
			if (this.tabId !== id) {
				this.$emit('layoutInit', {
					menus: name
				})
				this.$set(this, 'tabId', id);
				this.getList(1)
			}
		},

		getList(page = 1) {
			const params = {
				current: page
			};
			params.types = this.tabId === 1 ? '1,2' : '3,4';
			bothPublic(params).then(res => {
				this.setTableData(res);
			})
		},
		setTableData(response) {
			const { records, size, current, total } = response;
			this.$set(this, 'total', total || 0);
			this.$set(this, 'pageSize', size || 15);
			this.$set(this, 'list', records || []);
		},
		handleCurrentChange(e) {
			this.getList(e)
		}
	},
	computed: {},
	watch: {},
	filters: {
		timeFilter(time) {
			if (time) {
				return time.slice(0, 10);
			} else {
				return '';
			}
		}
	}
};
</script>
<style  lang="scss">
	@import '../assets/css/left.scss';
	.list-wrap {
		padding: 0 17px !important;
		.both-link {
			padding: 0 !important;
			& > a.flex {
				& > p {
					line-height: 55px;
					&:first-of-type {
						flex-grow: 2;
					}
				}
			}
		}
	}
</style>